/** Locale-aware formatting for loyalty. Locale follows the active i18next language. */

import { getIntlLocale } from '@/shared/i18n';

/** Format a point balance / threshold (thousands separated), or an em dash when absent. */
export function formatPoints(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(getIntlLocale()).format(value);
}

/** Format an ISO timestamp, or an em dash when absent/invalid. */
export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(getIntlLocale(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}
